import React, { Component } from 'react'
import StudentAssistentExamAsideBar from '../../navbars/StudentAssistentExamAsideBar';
import StudentAssistentExam from './StudentAssistentExamSection';
import { Container, Form, Modal, Button } from 'react-bootstrap';
import '../_preexam.scss';
import Select from 'react-select';

import gql from "graphql-tag";
import { graphql } from "react-apollo";
import * as Cookies from "es-cookie";
import * as compose from 'lodash.flowright';
import StudentAssistentExamNavbar from '../../navbars/StudentAssistentExamNavbar';
import PreloaderTwo from '../../preloader/PreloaderTwo';
import { withRouter } from "react-router-dom";
import Instructions from "../AssesmentInstructions";
import BrandLogo from '../../navbars/BrandLogo';


const SUBMIT_ASSESMENT_TEST = gql`
  mutation(
    $params:FinishStudentAssessmentExam  
    ) {
        finishStudentAssessmentExam(
        params: $params
     )
  }
`;

const PREPARE_QUESTION_PAPER = gql`
  mutation(
    $exam_session_id:Int  
    ) {
        studentAssessmentExam(
        exam_session_id: $exam_session_id
     ){
        id
              subject
                exam
                question
                option1
                option2
                option3
                option4
                qtype
                compquestion
                list1type
                list2type
                mat_question
                explanation
                answer
                inputquestion
                subject_name
     }
  }
`;

let stopExamStatus = "0";
class StudentAssistentExamMiddle extends Component {
    constructor(props) {
        super(props)
        this.state = {
            isSubmitted: false,
            index: 0,
            questions: [],
            submitStatus: 1,
            startPractise: "0",
            examLoader: 0,
            examSubjects: [],
            totaltimeup: 0,
            nextsubject: "0",
            reloader:"0"
        }
    }
    totTimeFunction = () => {
        this.setState({ totaltimeup: 1 });
        this.handleFormSubmit()
    }
    handleFormSubmit = e => {
        // e.preventDefault();
        
        let questions = [];
        this.state.questions.map((qmap, index) => {
            let attempted = "";
            if (qmap.attempted != null) {
                attempted = qmap.attempted;
            }
            const newObj = {
                question_id: parseInt(qmap.id),
                question_time: parseInt(qmap.timer),
                attempt_answer: attempted,
                slno: index + 1
            }
            questions.push(newObj);

        });
        
        let studentAssistObj = {
            exam_session_id: parseInt(this.props.exam_session_id),
            questions: questions
        };
        
        this.submitpt(
            studentAssistObj
        ).catch(error => {
            console.log("catch if error");
            console.log(error);
            this.setState({
                submitError: error.graphQLErrors.map(x => x.message)
            });
            console.error("ERR =>", error.graphQLErrors.map(x => x.message));
        });
        
    };
    submitpt = async (
        params) => {
        await this.props.submitpt({
            variables: {
                params
            },
            update: (store, { data }) => {
                
                if (data.finishStudentAssessmentExam) {
                    window.open(`https://rizee.in/assess-your-self/index.php?id=${this.props.exam_session_id}`, "_self");
                    

                }
            }
        });
    };

    timeFunction = () => {
        if(this.state.startPractise== "1"){
            let findArray = this.state.questions;
            let time = "";
            if (findArray != "" && this.state.submitStatus == 1 && findArray[this.state.index].isSubmitted != true) {
                time = findArray[this.state.index].timer + 1;
                findArray[this.state.index].timer = time;
            }
            this.setState({ questions: findArray }); 
        }
        
    }
    componentDidMount() {
        
        this.timer = setInterval(() => {
            this.timeFunction();
        }, 1000)

        if (stopExamStatus == "0") {
            
            // window.addEventListener("beforeunload", e => {
            //     e.preventDefault();
            //     e.returnValue = "";
            //     console.log("Before unload");
            //     alert("Window closed");
            // });

            const _isMounted = true;
            window.onpopstate = e => {
                const { hash } = this.props.history.location;

                
                if (!window.confirm("Are you sure to Leave this exam?")) {
                    
                    e.preventDefault();
                }
            };
        }

    }
    componentWillUnmount() {
        clearInterval(this.timer);
        //window.removeEventListener("beforeunload", this.handleWindow);
        window.removeEventListener("popstate", this.handleWindow);
    }
    handleInputChange2 = (option, question) => {
        let findStatus = this.state.questions.find((a) => a.id == question);
        let arr = this.state.questions;
        if(arr[this.state.index].attempted!=null){
            let samplearray=arr[this.state.index].attempted.split(",");
           if(samplearray.includes(option)){
            samplearray=samplearray.filter((a)=>a!=option);
           }
           else{
            samplearray.push(option);
           }
            arr[this.state.index].attempted = samplearray.toString();
            arr[this.state.index].status = "attempt";
        
        }
        else{
           
                arr[this.state.index].attempted = option;
                arr[this.state.index].status = "attempt";
        }
        
        
        this.setState({ questions: arr });
    };
    handleInputChange = (option, question) => {
        let findStatus = this.state.questions.find((a) => a.id == question);
        let arr = this.state.questions;
       
            arr[this.state.index].attempted = option;
            arr[this.state.index].status = "attempt";
        
        this.setState({ questions: arr });
    };
    FinalSaveFunction = () => {
        let arr = this.state.questions;
        arr[this.state.index].saveandnext = "1";
        let firstindex = this.state.index;
        let filterData = this.state.questions.filter((a) => a.sidebutton == "0" && a.status == "");
        if (filterData.length > 0) {
            if (arr[this.state.index].status == "") {
                arr[this.state.index].status = "skip";
            }
            this.state.questions.map((item, index) => {
                if (item.id == filterData[0].id) {
                    firstindex = index;
                }

            });
        }
        else {
            let filterData3 = this.state.questions.filter((a) => a.sidebutton == "0" && a.status == "skip");
            if (filterData3.length > 0) {
                if (arr[this.state.index].status == "") {
                    arr[this.state.index].status = "skip";
                }
                this.state.questions.map((item, index) => {
                    if (item.id == filterData3[0].id) {
                        firstindex = index;
                    }

                });
            }
        }
        this.setState({
            nextsubject: "0",

            index: firstindex,
            questions: arr
        },()=>this.handleFormSubmit);
        

       }
    SaveFunction = () => {
        let arr = this.state.questions;
        arr[this.state.index].saveandnext = "1";
        let firstindex = "";
        let filterData = this.state.questions.filter((a) => a.sidebutton == "0" && a.status == "" && a.id!=this.state.questions[this.state.index].id);
        if (filterData.length > 0) {
            this.state.questions.map((item, index) => {
                if (item.id == filterData[0].id) {
                    firstindex = index;
                }

            });
        }
        else {
            let filterData1 = this.state.questions.filter((a) => a.sidebutton == "0");
            this.state.questions.map((item, index) => {
                if (item.id == filterData1[0].id) {
                    firstindex = index;
                }

            });
        }

        if (arr[this.state.index].status == "") {
            arr[this.state.index].status = "skip";
        }
        //let filterlastindex = filterData.length - 1;
        //if (filterData[filterlastindex].id == arr[this.state.index + 1].id) {
        this.setState({
            nextsubject: "0",

            index: firstindex,
            questions: arr
        });
        //}


    }


    nextQuestionfunction = () => {
        
        let arr = this.state.questions;
        arr[this.state.index].saveandnext = "1";
        let filterData = this.state.questions.filter((a) => a.sidebutton == "0");
        let filterlastindex = filterData.length - 1;
        
        if (filterData[filterlastindex].id == arr[this.state.index + 1].id) {
            this.setState({
                nextsubject: "1"
            });
        }

        if (arr[this.state.index].lastindex != "") {
            
            //newcode
            if (arr[this.state.index].status == "") {
                arr[this.state.index].status = "skip"
            }
            
            if (arr[arr[this.state.index].lastindex].status == "") {
                this.setState({
                    index: arr[this.state.index].lastindex

                })
            }
            else {
                
                this.setState({
                    index: this.state.index + 1
                })
            }
            // end new code
        }
        else {
            let arr2 = this.state.questions[this.state.index];
            if (arr2.status != "") {
                let nextstatus = this.state.questions[this.state.index + 1].status;
                if (nextstatus == "") {
                    this.setState({
                        index: parseInt(this.state.index + 1),

                    })
                }
                else {
                    let findData = this.state.questions.filter((a) => a.sidebutton == "0" && a.status == "");
                    
                    let fobject = findData[0];
                    if (fobject != undefined) {
                        this.state.questions.map((item, index) => {
                            if (item.id == fobject.id) {
                                this.setState({
                                    index: index,

                                })
                            }

                        });
                    }
                    else {
                        this.setState({
                            index: parseInt(this.state.index + 1)
                        });
                    }
                 }


            }
            else {
                //newcode
                if (arr[this.state.index].status == "") {
                    arr[this.state.index].status = "skip"
                }
                //end newcode

                let nextstatus = this.state.questions[this.state.index + 1].status;
                if (nextstatus == "") {
                    this.setState({
                        index: parseInt(this.state.index + 1),

                    })
                }
                else {
                    let findData = this.state.questions.filter((a) => a.sidebutton == "0" && a.status == "");
                    
                    let fobject = findData[0];
                    if (fobject != undefined) {
                        this.state.questions.map((item, index) => {
                            if (item.id == fobject.id) {
                                this.setState({
                                    index: index,

                                })
                            }

                        });
                    }
                    else {
                        let findData5 = this.state.questions.filter((a) => a.sidebutton == "0");
                        
                        let fobject5 = findData5[0];
                        if (fobject5 != undefined) {
                            this.state.questions.map((item, index) => {
                                if (item.id == fobject5.id) {
                                    this.setState({
                                        index: index,

                                    })
                                }

                            });
                        }

                    }

                }

            }
        }
        this.setState({
            questions: arr
        });
    }
    handleIntegerInputChange = (e) => {
        

        // var pattern = new RegExp("^[-+]?[0-9]*$");
        var pattern = new RegExp(/^\d*\.?\d*$/);
        if (!pattern.test(e.target.value)) {
            
            let arr = this.state.questions;
            
            arr[this.state.index].attempted = null;
            arr[this.state.index].status = "";

            this.setState({ questions: arr });

        }
        else {
            
            let arr = this.state.questions;
            
                arr[this.state.index].attempted = e.target.value;
                arr[this.state.index].status = "attempt";
            
            this.setState({ questions: arr });
        }



    };
    clearoption = (e) => {
        
        let arr = this.state.questions;
        arr[this.state.index].result = "";
        arr[this.state.index].attempted = null;
        arr[this.state.index].status = "";

        this.setState({ questions: arr });
    }


    submitnext = () => {

        let arr = this.state.questions;
        let idata = arr[this.state.index];
        if (this.state.index == this.state.questions.length - 1) {
            if (idata.status == "") {
                arr[this.state.index].status = "skip";
                this.setState({
                    questions: arr,
                    lastqstatus: "2"
                })
            }
            else {
                arr[this.state.index].isSubmitted = true;
                this.setState({
                    isSubmitted: true
                })
            }
        }
        else {
            if (idata.status == "") {
                if (window.confirm("Do you want to skip this Question?")) {
                    arr[this.state.index].status = "skip";
                    this.setState({
                        questions: arr,
                        index: parseInt(this.state.index + 1),
                    })
                }
            }
            else {
                arr[this.state.index].isSubmitted = true;
                this.setState({
                    isSubmitted: true
                })
            }

        }
    }
    skip = () => {
        let arr = this.state.questions;
        if (arr[this.state.index].status == "") {
            arr[this.state.index].status = "skip";
            this.setState({
                index: parseInt(this.state.index + 1),
                questions: arr
            })
        }
        else {
            if (window.confirm("Do you want to skip this Question?")) {
                arr[this.state.index].status = "skip";
                arr[this.state.index].result = "";
                arr[this.state.index].attempted = null;
                this.setState({
                    questions: arr,
                    index: parseInt(this.state.index + 1),
                })
            }

        }
    }
    handleSelectChange = (name, value) => {
        let arr = this.state.questions;
        arr[this.state.index].reason = value;
        this.setState({
            questions: arr
        })
    }
    commentsFunction = (e) => {
        let arr = this.state.questions;
        arr[this.state.index].comments = e.target.value;
        this.setState({
            questions: arr
        })
    }

    sideQFun = (index) => {
        let arr = this.state.questions;
        let idata = arr[index];
        let filterData = this.state.questions.filter((a) => a.sidebutton == "0");
        let filterlastindex = filterData.length - 1;
        if (filterData[filterlastindex].id == arr[index].id) {
            this.setState({
                nextsubject: "1"
            });
        }
        else {
            this.setState({
                nextsubject: "0"
            });
        }
        
        if (index != this.state.index) {
            if (idata.status == "") {
                if (arr[this.state.index].status == "") {
                    if (window.confirm("Do you want to skip this Question?")) {
                        arr[this.state.index].status = "skip";
                        this.setState({
                            questions: arr,
                            index: index,
                        })
                    }
                }
                else {
                    this.setState({
                        index: index
                    })
                }

            }
            else {
                let findDat = this.state.questions.filter((a) => a.sidebutton == "0" && a.status == "");
                
                if (findDat.length > 0) {
                    if (idata.status == "skip") {
                        let latestindex = "";
                        for (let i = index + 1; i <= this.state.index; i++) {
                            let idata1 = this.state.questions[i];
                            if (idata1.status == "") {
                                latestindex = i;
                                break;
                            }
                        }
                        if (latestindex != "") {
                            arr[index].lastindex = latestindex;
                        }
                        else {
                            arr[index].lastindex = this.state.index;
                        }
                        this.setState({
                            questions: arr,
                            index: index
                        })
                    }
                    if (idata.status == "review") {
                        //arr[index].status = "";
                        let latestindex = "";
                        for (let i = index + 1; i <= this.state.index; i++) {
                            let idata = this.state.questions[i];
                            if (idata.status == "") {
                                latestindex = i;
                                break;
                            }
                        }
                        if (latestindex != "") {
                            arr[index].lastindex = latestindex;
                        }
                        else {
                            arr[index].lastindex = this.state.index;
                        }
                        this.setState({
                            questions: arr,
                            index: index
                        })
                    }
                    if (idata.status == "currect") {
                        arr[index].lastindex = this.state.index;
                        let latestindex = "";
                        for (let i = index + 1; i <= this.state.index; i++) {
                            let idata = this.state.questions[i];
                            if (idata.status == "") {
                                latestindex = i;
                                break;
                            }
                        }
                        if (latestindex != "") {
                            arr[index].lastindex = latestindex;
                        }
                        else {
                            arr[index].lastindex = this.state.index;
                        }
                        this.setState({
                            questions: arr,
                            index: index
                        })
                    }
                    if (idata.status == "wrong") {

                        arr[index].reasonstatus = "1";
                        arr[index].lastindex = this.state.index;
                        let latestindex = "";
                        for (let i = index + 1; i <= this.state.index; i++) {
                            let idata = this.state.questions[i];
                            if (idata.status == "") {
                                latestindex = i;
                                break;
                            }
                        }
                        if (latestindex != "") {
                            arr[index].lastindex = latestindex;
                        }
                        else {
                            arr[index].lastindex = this.state.index;
                        }
                        this.setState({
                            questions: arr,
                            index: index
                        })
                    }
                }
                else {
                    this.setState({ index: index });

                }



            }
        }
    }

    startPracticeFun = e => {
        e.preventDefault();
        this.setState({
            examLoader: 1
        });
        this.prepareQuestionPaper(
            parseInt(this.props.exam_session_id)
        ).catch(error => {
            console.log("catch if error");
            console.log(error);
            this.setState({
                submitError: error.graphQLErrors.map(x => x.message), examLoader: 0
            });
            console.error("ERR =>", error.graphQLErrors.map(x => x.message));
        });

    };
    prepareQuestionPaper = async (
        exam_session_id) => {
        await this.props.prepareQuestionPaper({
            variables: {
                exam_session_id
            },
            update: (store, { data }) => {
                
                if (data.studentAssessmentExam) {
                    let sectionSubject = 0;
                    let currentExamSubjects = [];

                    data.studentAssessmentExam.map(item => {
                        if (item.subject != sectionSubject) {
                            const subjectItem = { id: item.subject, subject: item.subject_name };
                            currentExamSubjects.push(subjectItem);
                        }
                    });
                    
                    let uniquecurrentExamSubjects = [];
                    currentExamSubjects.map((citem) => {
                        let filterdata = uniquecurrentExamSubjects.find((a) => a.id == citem.id);
                        if (filterdata != undefined) {
                            
                            if (filterdata.length == 0) {
                                const newObj = { ...citem, active: "" }
                                uniquecurrentExamSubjects.push(newObj);
                            }
                        }
                        else {
                            const newObj = { ...citem, active: "" }
                            uniquecurrentExamSubjects.push(newObj)
                        }

                    })
                    const allNewObj = {
                        id: 0,
                        subject: "ALL"
                    }
                    uniquecurrentExamSubjects.unshift(allNewObj);


                    let sampleArray = [];


                    for (let i = 0; i < data.studentAssessmentExam.length; i++) {
                        let newSubject = data.studentAssessmentExam[i];
                        const newarr1 = {
                            ...newSubject,
                            attempted: null,
                            timer: 0,
                            status: "",
                            reason: 0,
                            comments: "",
                            isSubmitted: false,
                            lastindex: "",
                            reasonstatus: "0",
                            saveandnext: "0",
                            sidebutton: "0"
                        }
                        sampleArray.push(newarr1);
                    }


                    this.setState({
                        examSubjects: uniquecurrentExamSubjects,
                        questions: sampleArray,
                        startPractise: "1",
                        examLoader: 0
                    });

                }
            }
        });
    };
    parentSubjectfilter = (subtype) => {
       

        if (subtype != 0) {
            let findData = this.state.questions.filter((a) => a.subject == subtype);
            
        }
          

        const subjectfilterQuetsions = this.state.questions.map((item) => {
            if (subtype != 0) {
                if (item.subject == subtype) {
                    return { ...item, sidebutton: "0" }
                } else {
                    return { ...item, sidebutton: "1" }
                }
            }
            else {
                return { ...item, sidebutton: "0" }
            }

        });
        let idindex = this.state.index;
        if (subtype != 0) {
            let subjectCountData = subjectfilterQuetsions.filter((a) => a.subject == subtype && a.saveandnext == "0" && a.sidebutton == "0" && a.status == "");
            
            if (subjectCountData.length > 0) {
                this.setState({
                    nextsubject: "0"
                });
            }


            if (subjectCountData != "") {
                this.state.questions.map((a, index) => {
                    if (a.id == subjectCountData[0].id) {
                        idindex = index;
                    }
                });
            }
            else {


                let filledData1 = subjectfilterQuetsions.filter((a) => a.subject == subtype && a.sidebutton == "0" && a.status == "skip");
                if (filledData1.length > 0) {
                    this.setState({
                        nextsubject: "0"
                    });
                }
                if (filledData1.length > 0) {
                    this.state.questions.map((a, index) => {
                        if (a.id == filledData1[0].id) {
                            idindex = index;
                        }
                    });
                }
                else {
                    let filledData3 = subjectfilterQuetsions.filter((a) => a.subject == subtype && a.sidebutton == "0");
                    if (filledData3.length > 0) {
                        this.setState({
                            nextsubject: "0"
                        });
                        this.state.questions.map((a, index) => {
                            if (a.id == filledData3[0].id) {
                                idindex = index;
                            }
                        });
                    }
                }

            }


           

        }
        else {
            let subjectCountData1 = subjectfilterQuetsions.filter((a) => a.saveandnext == "0" && a.sidebutton == "0" && a.status == "");
            
            if (subjectCountData1.length > 0) {
                this.setState({
                    nextsubject: "0"
                });
            }
            if (subjectCountData1 != "") {
                this.state.questions.map((a, index) => {
                    if (a.id == subjectCountData1[0].id) {
                        idindex = index;
                    }
                });
            }
            else {
                let filledData4 = subjectfilterQuetsions.filter((a) => a.sidebutton == "0" && a.status == "skip");

                if (filledData4.length > 0) {
                    this.setState({
                        nextsubject: "0"
                    });
                }
                if (filledData4.length > 0) {
                    this.state.questions.map((a, index) => {
                        if (a.id == filledData4[0].id) {
                            idindex = index;
                        }
                    });
                }
                else {
                    let filledData5 = subjectfilterQuetsions.filter((a) => a.sidebutton == "0");
                    if (filledData5.length > 0) {
                        this.setState({
                            nextsubject: "0"
                        });
                        this.state.questions.map((a, index) => {
                            if (a.id == filledData5[0].id) {
                                idindex = index;
                            }
                        });
                    }
                }

            }

            

        }





        this.setState({
            // nextsubject: "0",
            index: idindex,
            questions: subjectfilterQuetsions
        });
    }
    parentonScrollgetQuestionById=(questionData)=>{
        
        this.setState({
            reloader:"2"
        });
        const questions=this.state.questions.map((item)=>{
            if(item.id==questionData[0].id){
                return{...item,
                    question:questionData[0].question,
                    option1:questionData[0].option1,
                        option2:questionData[0].option2,
                        option3:questionData[0].option3,
                        option4:questionData[0].option4,
                        compquestion:questionData[0].compquestion,
                        list1type:questionData[0].list1type,
                        list2type:questionData[0].list2type,
                        mat_question:questionData[0].mat_question,
                       
                        inputquestion:questionData[0].inputquestion,
                        
                }

            }
            else{
                return{...item}
            }

        });
        
        this.setState({
            questions:questions,
            reloader:"1"
        });
        setTimeout(() => { this.SetreLoad() }, 1500);

    }
    SetreLoad = () => {
        this.setState({
            reloader:"0"
        });
    }
    render() {
        
        if (this.state.examLoader == 1) {
            return (<PreloaderTwo />);
        }

        else if (this.state.startPractise == "0") {
            return (
                <Instructions
                    type="exam"
                    examInstructions={this.props.getExamInstructions}
                    startPracticeFun={this.startPracticeFun}
                />
            )
        } else {
            if (this.state.totaltimeup == 1) {
                return (<React.Fragment>
                    <div className="main-wrapper-section w-100">
                        <div className="content-wrapper d-flex align-items-center text-center p-0">
                            <Container>
                                <div className="success-content-block py-3">
                                    <BrandLogo width="159.501" />
                                    <h5 className="mt-4">Your Exam Time Duration is completed.<br /> Auto-submitting your exam...</h5>
                                </div>
                            </Container>
                        </div>
                    </div>
                </React.Fragment>);
            } else {
                return (
                    <React.Fragment>
                        <div className="header-area-section">
                            <StudentAssistentExamNavbar
                                onClick={() => this.props.changeToggle()}
                                getData={this.props.getData}
                                totTimeFunction={this.totTimeFunction}
                                ParenthandleFormSubmit={this.handleFormSubmit}
                                getStudentAssessmentQuestions={this.state.questions}
                                stateData={this.state}
                            />
                        </div>

                        <div className="main-wrapper-section">

                            <StudentAssistentExamAsideBar
                                parentSubjectfilter={this.parentSubjectfilter}
                                stateData={this.state}
                                ParenthandleFormSubmit={this.handleFormSubmit}
                                getStudentAssessmentQuestions={this.state.questions}
                                psideQFun={this.sideQFun}
                            />
                            <div className="content-wrapper p-0" style={{ minHeight: '70vh' }}>
                                <Container>
                                    <StudentAssistentExam
                                    parentonScrollgetQuestionById={this.parentonScrollgetQuestionById}
                                        pCommentsFunction={this.commentsFunction}
                                        ParentSelecthandleChange={this.handleSelectChange}

                                        stateData={this.state}
                                        ParenthandleInputChange={this.handleInputChange}
                                        ParenthandleInputChange2={this.handleInputChange2}
                                        getStudentAssessmentQuestions={this.state.questions}
                                        PnextQuestionfunction={this.nextQuestionfunction}
                                        Psubmitnext={this.submitnext}
                                        Pskip={this.skip}
                                        Review={this.Review}


                                        parentselecthandleInputChange={this.selecthandleInputChange}
                                        parenticonhandleInputChange={this.iconhandleInputChange}
                                        phandleMutipleInputChange={this.handleMutipleInputChange}

                                        handleIntegerInputChange={this.handleIntegerInputChange}
                                        clearoption={this.clearoption}
                                        SaveFunction={this.SaveFunction}
                                        FinalSaveFunction={this.FinalSaveFunction}
                                        ParenthandleFormSubmit={this.handleFormSubmit}
                                    />
                                </Container>
                            </div>
                        </div>
                    </React.Fragment>
                )
            }

        }

    }


}

export default withRouter(
    compose(graphql(SUBMIT_ASSESMENT_TEST, {
        name: "submitpt"
    }), graphql(PREPARE_QUESTION_PAPER, {
        name: "prepareQuestionPaper"
    })
    )(StudentAssistentExamMiddle));




